// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/background_image.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Adiciona estilos à tabela */

.cards {
  height: 500px;
  border-radius: 15px !important;
  background-size: cover;
  background-position: center;
}


.cards:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}


.table-container {
  max-height: 400px; /* Ajuste conforme necessário */
  overflow-y: auto;
}

.card-container {
  max-height: 400px; /* Ajuste conforme necessário */
  overflow-y: auto;
}

.cards {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) -(var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
table {
  width: 100%;
  border-collapse: collapse;
}

/* Estiliza as células da tabela */
td, th {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

/* Estilo padrão para linhas da tabela */
tr {
  transition: background-color 0.3s ease;
}

/* Efeito hover para linhas da tabela */
tr:hover {
  background-color: rgb(24, 35, 182);
  border-radius: 8px;
  margin: 10px;
  padding: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  color: white; /* Muda a cor do texto para branco */
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/Companies.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,2BAA2B;AAC7B;;;AAGA;EACE,yDAAuD;AACzD;;;AAGA;EACE,iBAAiB,EAAE,+BAA+B;EAClD,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,+BAA+B;EAClD,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,gCAAgC;EAChC,uBAAuB;EACvB,0BAA0B;EAC1B,8CAA8C;EAC9C,0DAA0D;EAC1D,gDAAgD;EAChD,sBAAsB;EACtB,sFAAsF;EACtF,+BAA+B;EAC/B,6BAA6B;EAC7B,sDAAsD;EACtD,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,mCAAmC;EACnC,2BAA2B;EAC3B,qEAAqE;EACrE,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,wCAAwC;AACxC;EACE,sCAAsC;AACxC;;AAEA,uCAAuC;AACvC;EACE,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,wCAAwC;EACxC,YAAY,EAAE,oCAAoC;EAClD,eAAe;AACjB","sourcesContent":["/* Adiciona estilos à tabela */\n\n.cards {\n  height: 500px;\n  border-radius: 15px !important;\n  background-size: cover;\n  background-position: center;\n}\n\n\n.cards:hover {\n  background-image: url('../assets/background_image.jpg');\n}\n\n\n.table-container {\n  max-height: 400px; /* Ajuste conforme necessário */\n  overflow-y: auto;\n}\n\n.card-container {\n  max-height: 400px; /* Ajuste conforme necessário */\n  overflow-y: auto;\n}\n\n.cards {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: var(--bs-border-width);\n  --bs-card-border-color: var(--bs-border-color-translucent);\n  --bs-card-border-radius: var(--bs-border-radius);\n  --bs-card-box-shadow: ;\n  --bs-card-inner-border-radius: calc(var(--bs-border-radius) -(var(--bs-border-width)));\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: var(--bs-body-bg);\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n/* Estiliza as células da tabela */\ntd, th {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n/* Estilo padrão para linhas da tabela */\ntr {\n  transition: background-color 0.3s ease;\n}\n\n/* Efeito hover para linhas da tabela */\ntr:hover {\n  background-color: rgb(24, 35, 182);\n  border-radius: 8px;\n  margin: 10px;\n  padding: 5px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  color: white; /* Muda a cor do texto para branco */\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
